import React, { FC, PropsWithChildren } from 'react';

type PauseProps = {
  /** The color of the icon. */
  color?: string;
};

const Pause: FC<PropsWithChildren<PauseProps>> = ({ color = 'currentColor' }) => (
  <svg height="100%" version="1.1" viewBox="0 0 256 384" width="100%">
    <g>
      <path
        d="M96,371.8V12.1A12.1,12.1,0,0,0,83.8,0H12.2A12.1,12.1,0,0,0,0,12.1V371.8A12.18,12.18,0,0,0,12.2,384H83.8A12.12,12.12,0,0,0,96,371.8Z"
        fill={color}
      />
      <path
        d="M243.8,0H172.2A12.16,12.16,0,0,0,160,12.1V371.8A12.18,12.18,0,0,0,172.2,384h71.6A12.18,12.18,0,0,0,256,371.8V12.1A12.1,12.1,0,0,0,243.8,0Z"
        fill={color}
      />
    </g>
  </svg>
);

export default Pause;
